import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { MonitorFromWorkspaceApi, MonitorFromWorkspaceApiImpl } from '@/components/ai/plugins/tech-newsletter/services/apis/monitor-from-workspace';
import { IPatentLayoutApi } from './apis/patent-layout-api';
import { PatentLayoutApiImpl } from './apis/impls/patent-layout-api';
import { IPatentLayoutV2Api } from './apis/patent-layout-v2-api';
import { PatentLayoutV2ApiImpl } from './apis/impls/patent-layout-v2-api';
import { IPatentLinkApi } from './apis/patent-link-api';
import { PatentLinkApiImpl } from './apis/impls/patent-link-api';

export const ipServiceContainer = new ContainerModule(bind => {
    bind(MonitorFromWorkspaceApi).to(MonitorFromWorkspaceApiImpl);
    bind(IPatentLayoutApi).to(PatentLayoutApiImpl);
    bind(IPatentLayoutV2Api).to(PatentLayoutV2ApiImpl);
    bind(IPatentLinkApi).to(PatentLinkApiImpl);
});
